<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'normal-table-3';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
$border: 2pt solid #c0bec7;
.normal-table-3 {
  td {
    div {
      border-left: $border;
      border-bottom: $border;
    }
    &:last-child {
      div {
        border-right: $border;
      }
    }
  }
  th {
    &:not(.empty) {
      div {
        border-top: $border;
        border-left: $border;
      }
    }
    &:last-child {
      div {
        border-right: $border;
      }
    }
    &:first-child {
      div {
        border-left: $border;
      }
    }
  }
  thead {
    background-color: var(--theme-color-1);
    th {
      color: #fff;
    }
  }
  tbody {
    tr {
      &:nth-child(even) {
        td {
          background: var(--theme-color-1-10);
        }
      }
    }
  }
}
</style>
